export enum AppliedVoucherTypes {
  GIFT = 'GIFT',
  GENERIC_DISCOUNT = 'GENERIC_DISCOUNT',
  UNIQUE_DISCOUNT = 'UNIQUE_DISCOUNT',
  PAYBACK = 'PAYBACK',
  CREDIT = 'CREDIT',
  DV = 'DV',
}
